import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'
import last from 'lodash/last'

import { observer } from 'mobx-react'

import usePagination from 'modules/core/hooks/usePagination'
import i18n from 'modules/core/lib/i18n'

import type Employee from 'modules/employees/store/models/Employee'
import { usePlanningVersions } from 'modules/time_planning/store/collections/planningVersions'
import type PlanningVersion from 'modules/time_planning/store/models/PlanningVersion'

import Item from './Item'

interface Props {
  employees: Employee[]
}

const Body = ({ employees }: Props) => {
  const collectionPlanningVersions = usePlanningVersions()

  const { paginatedItems, loadMore, hasMore, page } = usePagination({
    batchSize: 50,
    items: employees,
  })

  if (employees.length === 0) {
    return (
      <Table.Body>
        <Table.Blank
          colSpan={12}
          text={i18n.t('settings.work_schedule.employees_tab.table.no_employees')}
        />
      </Table.Body>
    )
  }

  return (
    <Table.BodyWithInfiniteScroll page={page} loadMore={loadMore} hasMore={hasMore} colSpan={12}>
      {paginatedItems.map((employee) => {
        const planningVersion = last<PlanningVersion>(
          collectionPlanningVersions.workScheduleTool.filter(
            (planningVersion) => planningVersion.get('employee_id') === employee.id
          )
        )

        return (
          <Item key={employee.id} employee={employee} effectiveAt={planningVersion?.effectiveAt} />
        )
      })}
    </Table.BodyWithInfiniteScroll>
  )
}

export default observer(Body)
